module.exports = __webpack_public_path__ + "static/media/aeronave.625504f7.glb";